import Chart from "chart.js";

/**
 * helper function to add commas every 3 digits
 * @param rawIntNumber raw number
 * @returns {string} formatted string with commas
 */
export const addCommas = (rawIntNumber) => {
    if (rawIntNumber === undefined) {
        return 'N/A'
    }
    return rawIntNumber.toLocaleString('en-US');
};

export const addDataOnBar = (self, xOffset = 0, yOffset = 0) => {
    const chartInstance = self.chart;
    const ctx = chartInstance.ctx;
    ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
    ctx.fillStyle = "black";
    ctx.textAlign = 'center';
    ctx.textBaseline = 'bottom';
    chartInstance.data.datasets.forEach((dataset, i) => {
        const meta = chartInstance.controller.getDatasetMeta(i);
        meta.data.forEach((bar, index) => {
            const data = dataset.data[index];
            ctx.fillText(data, bar._model.x + xOffset, bar._model.y + yOffset);
        });
    });
};

export const splitItems = (items = []) => {
    const showCount = 3;
    if (items.length <= showCount) {
        return {
            showItems: items,
            leftItems: []
        }
    }
    return {
        showItems: items.slice(0, showCount),
        leftItems: items.slice(showCount)
    }
};


// WEBPACK FOOTER //
// ./src/modules/helpers.js